// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class CrisisAttachedFileInfo_abstract extends SagaObject {
  static $t: string = 'SagaSchema.CrisisAttachedFileInfo';
  $t: string = 'SagaSchema.CrisisAttachedFileInfo';

  public static GetMembers(): string[] {
    return ['AttachedFileInfoUid', 'FileName', 'FileInfo', 'FileSize', 'AttachedFileUid', 'ccCrisisMessageUID', 'FileExtension'].concat(
      SagaObject.GetMembers()
    );
  }

  public GetMembers(): string[] {
    return CrisisAttachedFileInfo_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public AttachedFileInfoUid: Guid = GuidTools.Empty;
  public FileName: string = '';
  public FileInfo: string = '';
  public FileSize: number = 0;
  public AttachedFileUid: Guid = GuidTools.Empty;
  public ccCrisisMessageUID: Guid = GuidTools.Empty;
  public FileExtension: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.AttachedFileInfoUid;
  }
  get ParentObjId(): any {
    return this.ccCrisisMessageUID;
  }
  set ParentObjId(value: any) {
    this.ccCrisisMessageUID = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
